import { useMutation, useQueryClient } from "@tanstack/vue-query";
import { ApiResponse } from "@/utils/ApiResponse";
import { useToast } from "vue-toastification";
import { DeleteModeloVehiculoAction } from "../../actions/modeloVehiculoActions";
import { ModelosVehiculoInterface } from "../../interfaces/modelovehiculosinterfaces/ModeloVehiculo.interface";

const toast = useToast();

export function useModeloVehiculoDelete(onClose?: () => void) {
  const queryClient = useQueryClient();

  // Mutation para eliminar el modelo de vehÃ­culo
  const mutation = useMutation({
    mutationFn: (modeloId: string) => DeleteModeloVehiculoAction(modeloId),

    onSuccess: async (response: ApiResponse<ModelosVehiculoInterface>) => {
      await queryClient.invalidateQueries({
        queryKey: ["ModeloVehiculosList"],
      });
      await queryClient.refetchQueries({
        queryKey: ["MarcaModeloList"],
        exact: true,
      });
      toast.success("El modelo de vehÃ­culo fue eliminado correctamente");
      if (onClose) onClose();
    },

    onError: (error: unknown) => {
      toast.error("Error al eliminar el modelo de vehÃ­culo");
      if (onClose) onClose();
    },
  });

  return {
    ...mutation, // => { mutate, mutateAsync, isPending, isError, error, isSuccess, data }
  };
}
